export default "__VITE_ASSET__D33RpjFn__"